<div class="edit-profile-container">
  <h2 mat-dialog-title>{{heading}}
    <button class="button-close" mat-icon-button aria-label="close" mat-dialog-close >
      <mat-icon aria-label="Close dialog">close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content class="form-content">
    @if(!isUpdated){<form class="signup-form" [formGroup]="profileForm">
      <div
        class="form-row"
        [ngClass]="{
          cnfPassword:
            profileForm.get('password')?.touched &&
            profileForm.get('password')?.errors?.['minlength'],
        }"
      >
        <div class="form-group">
          <app-text-input
            label="User name"
            [replaceDoubelQuotes]="true"
            [for]="'email-Input'"
            [control]="profileForm.controls['email']"
            [errorMessages]="errormessages"
          >
          </app-text-input>
        </div>
        <div class="form-group">
          <!-- <app-text-input
            [label]="'Delta Dental Company'"
            [control]="profileForm.controls['licenseState']"
          >
          </app-text-input> -->
          <app-text-input appPhoneMask [errorMessages]="errormessages" [label]="'Phone number'"
            [control]="profileForm.controls['phoneNumber']">
          </app-text-input>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <app-text-input
            label="Dentist first name"
            [fieldType]="'firstName'"
            [control]="profileForm.controls['dentistFirstName']"
            [maxLength]="50"
          >
          </app-text-input>
        </div>
        <div class="form-group">
          <app-text-input
            label="Dentist last name"
            [fieldType]="'lastName'"
            [control]="profileForm.controls['dentistLastName']"
            [maxLength]="50"
          >
          </app-text-input>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <app-text-input
            label="New password"
            [fieldType]="'Password'"
            [type]="'password'"
            [control]="profileForm.controls['password']"
            [errorMessages]="errormsg('Password')"
          >
          </app-text-input>
        </div>
        <div class="form-group">
          <app-text-input
            label="Confirm new password"
            [type]="'password'"
            [control]="profileForm.controls['confirmPassword']"
            [errorMessages]="errormessages"
          >
          </app-text-input>
        </div>
      </div>
      <!-- <div class="form-row">
                        <div class="form-group"> 
                            <app-text-input appPhoneMask [errorMessages]="errormessages" [label]="'Phone'" [control]="profileForm.controls['phoneNumber']">
                            </app-text-input>
                        </div> 
                    </div>-->
    </form>}
    @if(isUpdated){
      <div>You have successfully updated your profile</div>
      <div class="button-container">
        <app-button [label]="'Continue'" [buttonType]="'primary'" class="btn-cancel" mat-dialog-close
        ></app-button>
      </div>
    }
  </mat-dialog-content>
  <div class="mainError" *ngIf="mainError">{{ mainError }}</div>
  @if(!isUpdated){<mat-dialog-actions class="form-actions">
    <app-button [label]="'Cancel'" [buttonType]="'primary'" class="btn-cancel" mat-dialog-close
    ></app-button>
    <app-button [label]="'Update profile'" [buttonType]="'primary'" [isFilled]="true" (click)="updateProfile()"class="btn-update"
    ></app-button>
  </mat-dialog-actions>
}
</div>
